module.exports = __webpack_public_path__ + "static/media/universal.30b31ec5.jpg";